export default __webpack_public_path__ + "static/media/ic_profile.0ed944cc.svg";